const doc = [({"en":({"js":({"merfoto":({"layout":({"footer":({"write_us":"Write us", "call_us":"Call us", "opening_hours":"Opening hours", "copyright":"Copyright"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;